import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Template from "../../components/Template";
import api from "../../services/api"; // ou o caminho correto do seu arquivo de serviço
import { maskCpfCnpj, maskCep, maskCurrency, formatCurrencyFromDb } from "../../utils/masks";
import ConfirmationModal from "../../components/ConfirmationModal";
import SuccessModal from "../../components/SuccessModal";
import { formatDateWithHour, formatDateWithoutHour } from "../../utils/date";
import { parseCurrencyToFloat } from "../../utils/utils";
import config from "../../config";
import usePermission from "../../hooks/usePermission";
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import logoEmpresa from "../../components/logoEmpresaBase64";
import { useAuth } from '../../context/AuthContext';
import * as XLSX from "xlsx";

let tempAdesaoId = 90000;  // Contadores de ID local (para simular itens novos)
let tempDocId = 80000;

const CadastrarAta = ({ ataId }) => {
    const navigate = useNavigate();
    const { auth } = useAuth();
    const isEditMode = Boolean(ataId);
    const podeDeletar = usePermission("DELETAR_ATA");
    // Estados para armazenar arquivo do "Adesão" que está sendo criado
    const [fileAdesao, setFileAdesao] = useState(null);

    // Estados para armazenar arquivo do "Documento" que está sendo criado
    const [fileDocumento, setFileDocumento] = useState(null);

    const [fornecedores, setFornecedores] = useState([]);
    const [editais, setEditais] = useState([]);
    const [orgaos, setOrgaos] = useState([]);
    const [tiposDocumento, setTiposDocumento] = useState([]);

    const [adesoesRemovidas, setAdesoesRemovidas] = useState([]);
    const [docsRemovidos, setDocsRemovidos] = useState([]);

    // Estados para modais de confirmação/sucesso
    const [showConfirmDialog, setShowConfirmDialog] = useState(false);
    const [showSuccessDialog, setShowSuccessDialog] = useState(false);
    const [showConfirmDeleteRegister, setShowConfirmDeleteRegister] = useState(false);
    const [showConfirmRemoveArchiveDialog, setShowConfirmRemoveArchiveDialog] = useState(false);

    const [showPdfModal, setShowPdfModal] = useState(false);
    const [pdfUrl, setPdfUrl] = useState("");

    // Estado principal do formulário
    const [formData, setFormData] = useState({
        numeroAta: "", // Único campo obrigatório
        numeroProcesso: "",
        modalidade: "",
        numeroPregao: "",
        tipo: "",
        valorAta: "",
        percentualDesconto: "",
        // Contratante
        nomeContratante: "",
        cnpjContratante: "",
        enderecoContratante: "",
        municipioContratante: "",
        ufContratante: "",
        cepContratante: "",
        // Fornecedor
        nomeFornecedor: "",
        cnpjFornecedor: "",
        enderecoFornecedor: "",
        municipioFornecedor: "",
        ufFornecedor: "",
        cepFornecedor: "",
        // Detalhes Adicionais
        leiAplicavel: "",
        dataInicio: "",
        dataTermino: "",
        edital: "",
        objetoAta:
            "",
        observacoesAta:
            "",
        // Adesão
        orgaoSolicitante: "",
        valorSolicitado: "",
        numeroOficio: "",
        dataAdesao: "",
        // Documentos
        documentoAnexado: "",
        // Tabelas de adesões (exemplo fixo para demonstração)
        adesoes: [],
        // Reajuste
        reajustePermitido: false,
        dataInicioReajuste: "",
        dataTerminoReajuste: "",
        tipoIndice: "",
        // Documentação e Anexos
        tipoDocumento: "",
        prazoProrrogacao: "",
        arquivoDoc: null, // se quiser upload real
        // Tabela de documentos (exemplo fixo)
        docs: [],
    });

    // Busca o endereço pelo CEP usando ViaCEP
    const fetchAddressByCep = async () => {
        if (!formData.cepContratante || formData.cepContratante.length < 8) {
            alert("Insira um CEP válido.");
            return;
        }

        try {
            const response = await fetch(`https://viacep.com.br/ws/${formData.cepContratante}/json/`);
            const data = await response.json();

            if (data.erro) {
                alert("CEP não encontrado.");
                return;
            }

            // Atualiza os campos de endereço, município e estado
            setFormData((prev) => ({
                ...prev,
                enderecoContratante: data.logradouro || "",
                municipioContratante: data.localidade || "",
                //bairro: data.bairro || "",
                ufContratante: data.uf || "",
            }));
        } catch (error) {
            console.error("Erro ao buscar o endereço:", error);
            alert("Não foi possível buscar o endereço. Tente novamente.");
        }
    };

    // Busca o endereço pelo CEP usando ViaCEP
    const fetchAddressByCepFornecedor = async () => {
        if (!formData.cepFornecedor || formData.cepFornecedor.length < 8) {
            alert("Insira um CEP válido.");
            return;
        }

        try {
            const response = await fetch(`https://viacep.com.br/ws/${formData.cepFornecedor}/json/`);
            const data = await response.json();

            if (data.erro) {
                alert("CEP não encontrado.");
                return;
            }

            // Atualiza os campos de endereço, município e estado
            setFormData((prev) => ({
                ...prev,
                enderecoFornecedor: data.logradouro || "",
                municipioFornecedor: data.localidade || "",
                //bairro: data.bairro || "",
                ufFornecedor: data.uf || "",
            }));
        } catch (error) {
            console.error("Erro ao buscar o endereço:", error);
            alert("Não foi possível buscar o endereço. Tente novamente.");
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const [fornecedoresRes, editaisRes, orgaosRes, tiposDocumentoRes] = await Promise.all([
                    api.get("/fornecedores/todos"),
                    api.get('editais/todos'),
                    api.get('orgaosemissores'),
                    api.get('tiposdocumentos'),
                ]);
                setFornecedores(fornecedoresRes.data);
                setEditais(editaisRes.data);
                setOrgaos(orgaosRes.data);
                setTiposDocumento(tiposDocumentoRes.data);
            } catch (error) {
                console.error("Erro ao carregar dados:", error);
            }
        };
        fetchData();
    }, []);

    // Caso esteja editando, podemos carregar a ata do backend
    // 2) Se for edição, buscar dados da ATA no backend
    useEffect(() => {
        if (isEditMode) {
            api.get(`/atas/${ataId}`)
                .then((response) => {
                    const ata = response.data;
                    // Ajuste conforme a estrutura que seu backend retorna
                    // Exemplo: se o backend já retorna "dataInicio" no formato ISO "2023-07-10",
                    // basta atribuir diretamente. Se vier com "T00:00:00", podemos truncar.

                    setFormData((prev) => ({
                        ...prev,
                        numeroAta: ata.numeroAta || "",
                        numeroProcesso: ata.numeroProcesso || "",
                        modalidade: ata.modalidade || "",
                        numeroPregao: ata.numeroPregao || "",
                        tipo: ata.tipo || "",
                        valorAta: formatCurrencyFromDb(ata.valorAta),
                        percentualDesconto: ata.percentualDesconto || "",

                        nomeContratante: ata.nomeContratante || "",
                        cnpjContratante: ata.cnpjContratante || "",
                        enderecoContratante: ata.enderecoContratante || "",
                        municipioContratante: ata.municipioContratante || "",
                        ufContratante: ata.ufContratante || "",
                        cepContratante: ata.cepContratante || "",

                        nomeFornecedor: ata.nomeFornecedor || "",  // se no backend for "fornecedorId"
                        cnpjFornecedor: ata?.cnpjFornecedor ? maskCpfCnpj(ata.cnpjFornecedor) : "",
                        enderecoFornecedor: ata.enderecoFornecedor || "",
                        municipioFornecedor: ata.municipioFornecedor || "",
                        ufFornecedor: ata.ufFornecedor || "",
                        cepFornecedor: ata?.cepFornecedor ? maskCep(ata.cepFornecedor) : "",

                        leiAplicavel: ata.leiAplicavel || "",
                        dataInicio: ata.dataInicio ? ata.dataInicio.substring(0, 10) : "",
                        dataTermino: ata.dataTermino ? ata.dataTermino.substring(0, 10) : "",
                        edital: ata.editalId || "",   // se no backend for "editalId"
                        objetoAta: ata.objetoAta || "",
                        observacoesAta: ata.observacoesAta || "",

                        // Reajuste
                        reajustePermitido: ata.reajustePermitido || false,
                        dataInicioReajuste: ata.dataInicioReajuste ? ata.dataInicioReajuste.substring(0, 10) : "",
                        dataTerminoReajuste: ata.dataTerminoReajuste ? ata.dataTerminoReajuste.substring(0, 10) : "",
                        tipoIndice: ata.tipoIndice || "",

                        // Tabelas: adaptamos se "ata.adesoes" e "ata.docs" forem arrays
                        adesoes: ata.adesoes?.map((ad) => ({
                            id: ad.id,
                            orgaoSolicitante: ad.orgaoSolicitante.id, // ou o que seu backend retorna
                            nomeOrgaoSolicitante: ad.orgaoSolicitante.nome,
                            valorSolicitado: formatCurrencyFromDb(ad.valorSolicitado),
                            numeroOficio: ad.numeroOficio,
                            dataAdesao: ad.dataAdesao ? ad.dataAdesao.substring(0, 10) : "",
                            docAnexado: ad.docAnexado || "",
                            file: null, // sem arquivo local
                            arquivo: ad.arquivo
                        })) || [],

                        docs: ata.documentos?.map((doc) => ({
                            id: doc.id,
                            tipoDocumento: doc.tipo.id, // ou doc.tipoDocumento
                            nomeTipoDocumento: doc.tipo.nome,
                            dataEnvio: doc.dataEnvio || "",
                            file: null,
                            arquivo: doc.arquivo,
                            prazoProrrogacao: doc.prazoProrrogacao
                        })) || []
                    }));
                })
                .catch((error) => {
                    console.error("Erro ao carregar ATA para edição:", error);
                    alert("Não foi possível carregar a ATA para edição.");
                });
        }
    }, [isEditMode, ataId]);

    // Handler para arquivo de Adesão
    const handleAdesaoFileChange = (e) => {
        const file = e.target.files?.[0] || null;
        setFileAdesao(file);
    };

    // Handler para arquivo de Documento
    const handleDocumentoFileChange = (e) => {
        const file = e.target.files?.[0] || null;
        setFileDocumento(file);
    };

    // Manipula alterações nos inputs
    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        if (type === "checkbox" || type === "radio") {
            setFormData((prev) => ({ ...prev, [name]: checked }));
        } else {
            setFormData((prev) => ({ ...prev, [name]: value }));
        }
    };

    const handleCpfCnpjChange = (fieldName) => (e) => {
        const value = e.target.value;
        // Aplica a máscara
        const maskedValue = maskCpfCnpj(value);
        setFormData((prev) => ({
            ...prev,
            [fieldName]: maskedValue,
        }));
    };

    // Handler específico para CEP
    const handleCepChange = (fieldName) => (e) => {
        const value = e.target.value;
        // Aplica a máscara
        const maskedValue = maskCep(value);
        setFormData((prev) => ({
            ...prev,
            [fieldName]: maskedValue,
        }));
    };

    // Manipulador específico para campos de moeda
    const handleCurrencyChange = (fieldName) => (e) => {
        const originalValue = e.target.value;
        const masked = maskCurrency(originalValue);
        setFormData((prev) => ({ ...prev, [fieldName]: masked }));
    };

    // Adicionar Adesão na tabela
    // Adicionar nova Adesão
    const handleAddAdesao = () => {
        // Exemplo: se quiser exigir arquivo, valide if(!fileAdesao) ...
        // Verificamos se todos os campos obrigatórios estão preenchidos:
        if (!formData.orgaoSolicitante) {
            alert("Por favor, selecione o Órgão Solicitante.");
            return;
        }
        if (!formData.valorSolicitado || formData.valorSolicitado === "R$ 00,00") {
            alert("Por favor, informe o Valor Solicitado.");
            return;
        }
        if (!formData.numeroOficio) {
            alert("Por favor, informe o Número do Ofício.");
            return;
        }
        if (!formData.dataAdesao) {
            alert("Por favor, informe a Data da Adesão.");
            return;
        }
        if (!fileAdesao) {
            alert("É necessário selecionar um arquivo para a Adesão.");
            return;
        }
        tempAdesaoId++;
        const newAdesao = {
            id: tempAdesaoId,
            orgaoSolicitante: formData.orgaoSolicitante || "N/A",
            valorSolicitado: parseCurrencyToFloat(formData.valorSolicitado) || "R$ 00,00",
            numeroOficio: formData.numeroOficio || "",
            dataAdesao: formData.dataAdesao || "",
            // docAnexado => nome do arquivo
            docAnexado: fileAdesao ? fileAdesao.name : "",
            file: fileAdesao, // guardamos o File para envio posterior
        };
        // adiciona ao array
        setFormData((prev) => ({
            ...prev,
            adesoes: [...prev.adesoes, newAdesao],
            // limpa os campos
            orgaoSolicitante: "",
            valorSolicitado: "R$ 00,00",
            numeroOficio: "",
            dataAdesao: "",
        }));
        setFileAdesao(null); // limpa o input file do adesão
    };
    // Exemplo de remoção de uma adesão
    const handleRemoveAdesao = (idItem) => {
        setFormData((prev) => ({
            ...prev,
            adesoes: prev.adesoes.filter((x) => x.id !== idItem),
        }));
        setAdesoesRemovidas((prev) => [...prev, idItem]); // Adiciona o ID à lista de removidos
    };

    // Adicionar Documento na tabela
    // Adicionar novo Documento
    const handleAddDocumento = () => {
        // Verificar se todos campos obrigatórios estão preenchidos:
        if (!formData.tipoDocumento) {
            alert("Por favor, selecione o Tipo de Documento.");
            return;
        }
        if (!fileDocumento) {
            alert("É necessário selecionar um arquivo para o Documento.");
            return;
        }
        tempDocId++;
        const newDoc = {
            id: tempDocId,
            tipoDocumento: formData.tipoDocumento || "Sem tipo",
            dataEnvio: formData.docDataEnvio || new Date().toISOString(),
            file: fileDocumento,
            prazoProrrogacao: formData.prazoProrrogacao
        };

        setFormData((prev) => ({
            ...prev,
            docs: [...prev.docs, newDoc],
            tipoDocumento: "",
            docDataEnvio: "",
            prazoProrrogacao: ""
        }));
        setFileDocumento(null);
    };

    // Exemplo de remoção de um documento
    const handleRemoveDoc = (idDoc) => {
        setFormData((prev) => ({
            ...prev,
            docs: prev.docs.filter((doc) => doc.id !== idDoc),
        }));
        setDocsRemovidos((prev) => [...prev, idDoc]); // Adiciona o ID à lista de removidos
    };

    /**
     * Quando o usuário selecionar um fornecedor no <select>,
     * buscamos o fornecedor na lista e preenchemos campos.
     */
    const handleSelectFornecedor = (e) => {
        const selectedId = e.target.value;
        setFormData((prev) => ({ ...prev, fornecedor: selectedId }));

        // Encontrar o fornecedor no array
        const found = fornecedores.find((f) => f.id === parseInt(selectedId, 10));
        if (found) {
            // Preencher campos do formData
            setFormData((prev) => ({
                ...prev,
                fornecedorCnpj: found?.cpfCnpj ? maskCpfCnpj(found.cpfCnpj) : "",
                fornecedorEndereco: found.endereco || "",
                fornecedorMunicipio: found.municipio || "",
                fornecedorUf: found.uf || "",
                fornecedorCep: found?.cep ? maskCep(found.cep) : "",
            }));
        } else {
            // Se não achou, limpa
            setFormData((prev) => ({
                ...prev,
                fornecedorCnpj: "",
                fornecedorEndereco: "",
                fornecedorMunicipio: "",
                fornecedorUf: "",
                fornecedorCep: "",
            }));
        }
    };

    const handleViewPdf = (url) => {
        setPdfUrl(url);
        setShowPdfModal(true);
    };

    // Cancelar modal de confirmação
    const handleCancelSubmit = () => {
        setShowConfirmDialog(false);
    };

    // Manipulador para voltar à página anterior
    const handleBack = () => {
        navigate("/atas");
    };

    // Manipulador para apagar o contrato (apenas no modo de edição)
    const handleDeleteRegister = async () => {
        try {
            await api.delete(`/atas/${ataId}`);
            setShowConfirmDeleteRegister(false);
            navigate("/atas");
        } catch (error) {
            console.error("Erro ao remover ata:", error);
            alert("Erro ao remover ata.");
        }
    };

    // Submeter
    const handleSubmit = (e) => {
        e.preventDefault();
        setShowConfirmDialog(true);
    };

    const handleConfirmSubmit = async (e) => {
        setShowConfirmDialog(false);
        // Validar único obrigatório
        if (!formData.numeroAta.trim()) {
            alert("O campo 'Número ATA' é obrigatório.");
            return;
        }

        try {
            const dataToSend = new FormData();
            dataToSend.append("numeroAta", formData.numeroAta);
            dataToSend.append("numeroProcesso", formData.numeroProcesso);
            dataToSend.append("modalidade", formData.modalidade);
            dataToSend.append("numeroPregao", formData.numeroPregao);
            dataToSend.append("tipo", formData.tipo);
            dataToSend.append("valorAta", formData.valorAta ? parseCurrencyToFloat(formData.valorAta) : 0);
            dataToSend.append("percentualDesconto", formData.percentualDesconto);

            dataToSend.append("nomeContratante", formData.nomeContratante);
            dataToSend.append("cnpjContratante", formData.cnpjContratante);
            dataToSend.append("enderecoContratante", formData.enderecoContratante);
            dataToSend.append("municipioContratante", formData.municipioContratante);
            dataToSend.append("ufContratante", formData.ufContratante);
            dataToSend.append("cepContratante", formData.cepContratante);

            dataToSend.append("nomeFornecedor", formData.nomeFornecedor);
            dataToSend.append("cnpjFornecedor", formData.cnpjFornecedor);
            dataToSend.append("enderecoFornecedor", formData.enderecoFornecedor);
            dataToSend.append("municipioFornecedor", formData.municipioFornecedor);
            dataToSend.append("ufFornecedor", formData.ufFornecedor);
            dataToSend.append("cepFornecedor", formData.cepFornecedor);



            dataToSend.append("leiAplicavel", formData.leiAplicavel);
            dataToSend.append("dataInicio", formData.dataInicio);
            dataToSend.append("dataTermino", formData.dataTermino);
            dataToSend.append("edital", formData.edital);
            dataToSend.append("objetoAta", formData.objetoAta);
            dataToSend.append("observacoesAta", formData.observacoesAta);

            // Reajuste
            dataToSend.append("reajustePermitido", formData.reajustePermitido);
            dataToSend.append("dataInicioReajuste", formData.dataInicioReajuste);
            dataToSend.append("dataTerminoReajuste", formData.dataTerminoReajuste);
            dataToSend.append("tipoIndice", formData.tipoIndice);

            // Adesões -> array JSON
            dataToSend.append("adesoes", JSON.stringify(formData.adesoes));
            // Documentos -> array JSON
            dataToSend.append("docs", JSON.stringify(formData.docs));

            // Enviar cada arquivo que estiver no array
            formData.adesoes.forEach((item, index) => {
                if (item.file) {
                    dataToSend.append(`adesoesFiles[${index}]`, item.file);
                }
            });
            formData.docs.forEach((doc, index) => {
                if (doc.file) {
                    dataToSend.append(`docsFiles[${index}]`, doc.file);
                }
            });

            dataToSend.append("adesoesRemovidas", JSON.stringify(adesoesRemovidas));
            dataToSend.append("docsRemovidos", JSON.stringify(docsRemovidos));

            // Se isEditMode => PUT, senão POST
            let response = null;
            if (isEditMode) {
                response = await api.put(`/atas/${ataId}`, dataToSend, {
                    headers: { "Content-Type": "multipart/form-data" },
                });
            } else {
                response = await api.post("/atas", dataToSend, {
                    headers: { "Content-Type": "multipart/form-data" },
                });
            }
            if (response.status === 200 || response.status === 201) {
                setShowSuccessDialog(true);
                setTimeout(() => {
                    setShowSuccessDialog(false);
                    if (isEditMode) {
                        window.location.href = `/atas/editar/${ataId}`;
                    } else {
                        window.location.href = `/atas`;
                    }
                }, 3000);
                setAdesoesRemovidas([]);
                setDocsRemovidos([]);
            } else {
                throw new Error("Erro ao salvar ata");
            }
        } catch (error) {
            console.error(`Erro ao ${isEditMode ? "atualizar" : "cadastrar"} contrato:`, error);
            alert("Ocorreu um erro. Verifique os dados e tente novamente.");
        }
    };

    const exportarRelatorioAdesoes = (formData, orgaos, usuarioAtual = "", logoEmpresa) => {
        const doc = new jsPDF({ orientation: "landscape" }); // Paisagem igual ao exemplo

        let posY = 20;

        // Título
        doc.setFontSize(16);
        doc.text(`RESUMO ADESÕES À ATA DE REGISTRO DE PREÇO Nº ${formData.numeroAta}`, 14, posY);
        posY += 10;

        // Valor Contrato (superior)
        const valorContrato = formData.valorAta;
        doc.setFontSize(12);
        doc.text(`VALOR CONTRATO: ${valorContrato}`, 14, posY);
        posY += 8;

        // Monta os dados da tabela
        const tabelaAdesoes = formData.adesoes.map((ad) => {
            const orgao = orgaos.find(o => o.id === parseInt(ad.orgaoSolicitante, 10));
            const nomeOrgao = orgao ? orgao.nome : ad.orgaoSolicitante;

            // Valor aderido (string formatada)
            let valorAderido = ad.valorSolicitado;
            if (typeof valorAderido === "number") {
                valorAderido = valorAderido.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
            } else if (!String(valorAderido).includes("R$")) {
                valorAderido = Number(valorAderido).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
            }

            // Percentual de adesão se houver no objeto, ou calcula:
            let percentual = ad.percentualAdesao;
            if (!percentual && valorContrato) {
                const valorNum = Number(
                    String(ad.valorSolicitado).replace("R$", "").replace(/\./g, "").replace(",", ".")
                );
                const contratoNum = Number(
                    String(valorContrato).replace("R$", "").replace(/\./g, "").replace(",", ".")
                );
                percentual = ((valorNum / contratoNum) * 100).toFixed(2) + "%";
            }

            // Valor empenhado se houver
            let valorEmpenhado = ad.valorEmpenhado || "";
            if (valorEmpenhado && typeof valorEmpenhado === "number") {
                valorEmpenhado = valorEmpenhado.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
            }

            return [
                nomeOrgao,
                valorAderido,
                percentual,
                valorEmpenhado,
            ];
        });

        // Tabela de adesões
        autoTable(doc, {
            startY: posY,
            headStyles: { fillColor: [30, 120, 180] },
            head: [['SECRETARIA/ÓRGÃO', 'VALOR ADERIDO', 'PERCENTUAL DE ADESÃO', 'VALOR EMPENHADO']],
            body: tabelaAdesoes,
            styles: { fontSize: 10 }
        });

        posY = doc.lastAutoTable.finalY + 10;

        // Totais
        // Calcular total aderido
        let totalAderido = 0;
        formData.adesoes.forEach(ad => {
            let v = ad.valorSolicitado;
            if (typeof v === "string") {
                v = Number(v.replace("R$", "").replace(/\./g, "").replace(",", "."));
            }
            totalAderido += (Number(v) || 0);
        });

        // Valor do contrato
        let contratoNum = valorContrato;
        if (typeof contratoNum === "string") {
            contratoNum = Number(contratoNum.replace("R$", "").replace(/\./g, "").replace(",", "."));
        }

        const totalAderidoFmt = totalAderido.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
        const contratoFmt = (contratoNum || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
        const percentualAderido = contratoNum ? ((totalAderido / contratoNum) * 100).toFixed(2) + "%" : "";

        const totalRestante = (contratoNum || 0) - totalAderido;
        const totalRestanteFmt = totalRestante.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
        const percentualRestante = contratoNum ? ((totalRestante / contratoNum) * 100).toFixed(2) + "%" : "";

        // Linha dos totais
        autoTable(doc, {
            startY: posY,
            headStyles: { fillColor: [30, 120, 180] },
            head: [['DESCRIÇÃO', 'VALOR', 'PERCENTUAL']],
            body: [
                ['VALOR TOTAL ADERIDO', totalAderidoFmt, percentualAderido],
                ['VALOR RESTANTE - QUE AINDA PODE SER ADERIDO', totalRestanteFmt, percentualRestante]
            ]
        });

        // Footer
        const paginas = doc.getNumberOfPages();
        const dataEmissao = new Date().toLocaleString('pt-BR');
        for (let i = 1; i <= paginas; i++) {
            doc.setPage(i);
            doc.setFontSize(8);
            doc.setTextColor(100);
            doc.text(`Emitido por: ${usuarioAtual || "Sistema"}`, 14, 200);
            doc.text(`Data/Hora: ${dataEmissao}`, 14, 205);
            doc.text(`Página ${i} de ${paginas}`, 285, 205, { align: 'right' });

            // Logo
            if (logoEmpresa) {
                const logoWidth = 50, logoHeight = 15, pageWidth = doc.internal.pageSize.getWidth();
                doc.addImage(logoEmpresa, 'PNG', (pageWidth - logoWidth) / 2, 190, logoWidth, logoHeight);
            }
        }

        // Salvar
        doc.save(`resumo-adesoes-ata-${formData.numeroAta}.pdf`);
    };

    function parseBRL(valor) {
        if (typeof valor === "number") return valor;
        return Number(
            String(valor || "")
                .replace("R$", "")
                .replace(/\./g, "")
                .replace(",", ".")
                .trim()
        ) || 0;
    }

    const exportarRelatorioAdesoesExcel = (formData, orgaos) => {
        // Monta os dados da tabela principal
        const dadosAdesoes = (formData.adesoes || []).map((ad) => {
            const orgao = orgaos.find(o => o.id === parseInt(ad.orgaoSolicitante, 10));
            const nomeOrgao = orgao ? orgao.nome : ad.orgaoSolicitante;

            const valorAderido = parseBRL(ad.valorSolicitado);
            const valorAderidoFmt = valorAderido.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

            // Percentual de adesão
            let percentual = ad.percentualAdesao;
            let valorContrato = parseBRL(formData.valorAta);
            if (!percentual && valorContrato) {
                percentual = valorContrato > 0 ? ((valorAderido / valorContrato) * 100).toFixed(2) + "%" : "";
            }

            let valorEmpenhado = ad.valorEmpenhado ? parseBRL(ad.valorEmpenhado) : "";
            let valorEmpenhadoFmt = valorEmpenhado !== "" ? valorEmpenhado.toLocaleString("pt-BR", { style: "currency", currency: "BRL" }) : "";

            return {
                "Secretaria/Órgão": nomeOrgao,
                "Valor Aderido": valorAderidoFmt,
                "Percentual de Adesão": percentual,
                "Valor Empenhado": valorEmpenhadoFmt
            };
        });

        // Totais
        const valorContrato = parseBRL(formData.valorAta);
        const totalAderido = dadosAdesoes.reduce((acc, row) => acc + parseBRL(row["Valor Aderido"]), 0);
        const totalRestante = valorContrato - totalAderido;

        const percentualAderido = valorContrato ? ((totalAderido / valorContrato) * 100).toFixed(2) + "%" : "";
        const percentualRestante = valorContrato ? ((totalRestante / valorContrato) * 100).toFixed(2) + "%" : "";

        // Linhas de totais ao final da planilha
        dadosAdesoes.push({});
        dadosAdesoes.push({
            "Secretaria/Órgão": "VALOR TOTAL ADERIDO",
            "Valor Aderido": totalAderido.toLocaleString("pt-BR", { style: "currency", currency: "BRL" }),
            "Percentual de Adesão": percentualAderido,
            "Valor Empenhado": ""
        });
        dadosAdesoes.push({
            "Secretaria/Órgão": "VALOR RESTANTE - QUE AINDA PODE SER ADERIDO",
            "Valor Aderido": totalRestante.toLocaleString("pt-BR", { style: "currency", currency: "BRL" }),
            "Percentual de Adesão": percentualRestante,
            "Valor Empenhado": ""
        });

        // Gera o arquivo
        const ws = XLSX.utils.json_to_sheet(dadosAdesoes, { skipHeader: false });
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Adesões");

        XLSX.writeFile(
            wb,
            `resumo-adesoes-ata-${formData.numeroAta || ""}.xlsx`
        );
    };



    return (
        <Template>
            <form onSubmit={handleSubmit} className="w-full px-4 py-6 flex flex-col gap-8">
                {/* Título da Página */}
                <div>
                    <h1 className="text-2xl text-stone-800 font-medium">
                        {isEditMode ? "Editar ATA" : "Cadastrar ATA"}
                    </h1>
                </div>

                {/* Informações Básicas */}
                <div className="flex flex-col gap-4">
                    <h2 className="text-base text-stone-600 font-medium">Informações Básicas</h2>

                    <div className="flex flex-col gap-4">
                        {/* Linha 1 */}
                        <div className="flex flex-col md:flex-row flex-wrap gap-4">
                            {/* Número ATA (Único obrigatório) */}
                            <div className="flex-1 min-w-[200px] flex flex-col">
                                <label className="text-sm font-medium text-slate-700">Número ATA *</label>
                                <input
                                    type="text"
                                    name="numeroAta"
                                    value={formData.numeroAta}
                                    onChange={handleInputChange}
                                    className="px-3 py-2 bg-white rounded-md border border-slate-300"
                                    required
                                />
                            </div>
                            {/* Número do Processo Licitatório */}
                            <div className="flex-1 min-w-[200px] flex flex-col">
                                <label className="text-sm font-medium text-slate-700">
                                    Número do Processo Licitatório
                                </label>
                                <input
                                    type="text"
                                    name="numeroProcesso"
                                    value={formData.numeroProcesso}
                                    onChange={handleInputChange}
                                    className="px-3 py-2 bg-white rounded-md border border-slate-300"
                                />
                            </div>
                            {/* Modalidade */}
                            <div className="flex-1 min-w-[200px] flex flex-col">
                                <label className="text-sm font-medium text-slate-700">Modalidade</label>
                                <input
                                    type="text"
                                    name="modalidade"
                                    value={formData.modalidade}
                                    onChange={handleInputChange}
                                    className="px-3 py-2 bg-white rounded-md border border-slate-300"
                                />
                            </div>
                        </div>

                        {/* Linha 2 */}
                        <div className="flex flex-col md:flex-row flex-wrap gap-4">
                            {/* Número do Pregão */}
                            <div className="flex-1 min-w-[200px] flex flex-col">
                                <label className="text-sm font-medium text-slate-700">Número do Pregão</label>
                                <input
                                    type="text"
                                    name="numeroPregao"
                                    value={formData.numeroPregao}
                                    onChange={handleInputChange}
                                    className="px-3 py-2 bg-white rounded-md border border-slate-300"
                                />
                            </div>
                            {/* Tipo */}
                            <div className="flex-1 min-w-[200px] flex flex-col">
                                <label className="text-sm font-medium text-slate-700">Tipo</label>
                                <input
                                    type="text"
                                    name="tipo"
                                    value={formData.tipo}
                                    onChange={handleInputChange}
                                    className="px-3 py-2 bg-white rounded-md border border-slate-300"
                                />
                            </div>
                            {/* Valor da ATA */}
                            <div className="flex-1 min-w-[200px] flex flex-col">
                                <label className="text-sm font-medium text-slate-700">Valor da ATA</label>
                                <input
                                    type="text"
                                    name="valorAta"
                                    value={formData.valorAta}
                                    onChange={handleCurrencyChange('valorAta')}
                                    className="px-3 py-2 bg-white rounded-md border border-slate-300"
                                />
                            </div>
                            {/* Percentual de Desconto */}
                            <div className="flex-1 min-w-[200px] flex flex-col">
                                <label className="text-sm font-medium text-slate-700">
                                    Percentual de Desconto (%)
                                </label>
                                <input
                                    type="text"
                                    name="percentualDesconto"
                                    value={formData.percentualDesconto}
                                    onChange={handleInputChange}
                                    className="px-3 py-2 bg-white rounded-md border border-slate-300"
                                />
                            </div>
                        </div>
                    </div>
                </div>

                {/* Contratante */}
                <div className="flex flex-col gap-4">
                    <h2 className="text-base text-stone-600 font-medium">Contratante</h2>
                    <div className="flex flex-col md:flex-row flex-wrap gap-4">
                        {/* Nome Contratante */}
                        <div className="flex-1 min-w-[200px] flex flex-col">
                            <label className="text-sm font-medium text-slate-700">Nome do Contratante</label>
                            <input
                                type="text"
                                name="nomeContratante"
                                value={formData.nomeContratante}
                                onChange={handleInputChange}
                                className="px-3 py-2 bg-white rounded-md border border-slate-300"
                            />
                        </div>
                        {/* CNPJ */}
                        <div className="w-[375px] flex flex-col">
                            <label className="text-sm font-medium text-slate-700">CNPJ</label>
                            <input
                                type="text"
                                name="cnpjContratante"
                                value={formData.cnpjContratante}
                                onChange={handleCpfCnpjChange("cnpjContratante")}
                                className="px-3 py-2 bg-white rounded-md border border-slate-300"
                            />
                        </div>
                    </div>
                    <div className="flex flex-col md:flex-row flex-wrap gap-4">
                        {/* CEP */}
                        <div className="flex-1 min-w-[200px] flex flex-col">
                            <label className="text-sm font-medium text-slate-700">CEP</label>
                            <input
                                type="text"
                                name="cepContratante"
                                value={formData.cepContratante}
                                onChange={handleCepChange("cepContratante")}
                                onBlur={fetchAddressByCep}
                                className="px-3 py-2 bg-white rounded-md border border-slate-300"
                            />
                        </div>
                        {/* Endereço */}
                        <div className="flex-1 min-w-[200px] flex flex-col">
                            <label className="text-sm font-medium text-slate-700">Endereço</label>
                            <input
                                type="text"
                                name="enderecoContratante"
                                value={formData.enderecoContratante}
                                onChange={handleInputChange}
                                className="px-3 py-2 bg-white rounded-md border border-slate-300"
                            />
                        </div>
                        {/* Município */}
                        <div className="flex-1 min-w-[200px] flex flex-col">
                            <label className="text-sm font-medium text-slate-700">Município</label>
                            <input
                                type="text"
                                name="municipioContratante"
                                value={formData.municipioContratante}
                                onChange={handleInputChange}
                                className="px-3 py-2 bg-white rounded-md border border-slate-300"
                            />
                        </div>
                        {/* UF */}
                        <div className="w-[130px] flex flex-col">
                            <label className="text-sm font-medium text-slate-700">UF</label>
                            <input
                                type="text"
                                name="ufContratante"
                                value={formData.ufContratante}
                                onChange={handleInputChange}
                                className="px-3 py-2 bg-white rounded-md border border-slate-300"
                            />
                        </div>

                    </div>
                </div>

                {/* Fornecedor */}
                <div className="flex flex-col gap-4">
                    <h2 className="text-base text-stone-600 font-medium">Fornecedor</h2>
                    <div className="flex flex-col md:flex-row flex-wrap gap-4">
                        {/* Fornecedor */}
                        <div className="flex-1 min-w-[200px] flex flex-col">
                            <label className="text-sm font-medium text-slate-700">Nome do Fornecedor</label>
                            <input
                                type="text"
                                name="nomeFornecedor"
                                value={formData.nomeFornecedor}
                                onChange={handleInputChange}
                                className="px-3 py-2 bg-white rounded-md border border-slate-300"
                            />
                        </div>
                        {/* CNPJ Fornecedor */}
                        <div className="w-[375px] flex flex-col">
                            <label className="text-sm font-medium text-slate-700">CNPJ</label>
                            <input
                                type="text"
                                name="cnpjFornecedor"
                                value={formData.cnpjFornecedor}
                                onChange={handleCpfCnpjChange("cnpjFornecedor")}
                                className="px-3 py-2 bg-white rounded-md border border-slate-300"
                            />
                        </div>
                    </div>
                    <div className="flex flex-col md:flex-row flex-wrap gap-4">
                        {/* CEP */}
                        <div className="flex-1 min-w-[200px] flex flex-col">
                            <label className="text-sm font-medium text-slate-700">CEP</label>
                            <input
                                type="text"
                                name="cepFornecedor"
                                value={formData.cepFornecedor}
                                onChange={handleCepChange("cepFornecedor")}
                                onBlur={fetchAddressByCepFornecedor}
                                className="px-3 py-2 bg-white rounded-md border border-slate-300"
                            />
                        </div>
                        {/* Endereço */}
                        <div className="flex-1 min-w-[200px] flex flex-col">
                            <label className="text-sm font-medium text-slate-700">Endereço</label>
                            <input
                                type="text"
                                name="enderecoFornecedor"
                                value={formData.enderecoFornecedor}
                                onChange={handleInputChange}
                                className="px-3 py-2 bg-white rounded-md border border-slate-300"
                            />
                        </div>
                        {/* Município */}
                        <div className="flex-1 min-w-[200px] flex flex-col">
                            <label className="text-sm font-medium text-slate-700">Município</label>
                            <input
                                type="text"
                                name="municipioFornecedor"
                                value={formData.municipioFornecedor}
                                onChange={handleInputChange}
                                className="px-3 py-2 bg-white rounded-md border border-slate-300"
                            />
                        </div>
                        {/* UF */}
                        <div className="w-[130px] flex flex-col">
                            <label className="text-sm font-medium text-slate-700">UF</label>
                            <input
                                type="text"
                                name="ufFornecedor"
                                value={formData.ufFornecedor}
                                onChange={handleInputChange}
                                className="px-3 py-2 bg-white rounded-md border border-slate-300"
                            />
                        </div>
                    </div>
                </div>

                {/* Detalhes Adicionais */}
                <div className="flex flex-col gap-4">
                    <h2 className="text-base text-stone-600 font-medium">Detalhes Adicionais</h2>
                    <div className="flex flex-col md:flex-row flex-wrap gap-4">
                        {/* Lei Aplicável */}
                        <div className="flex-1 min-w-[200px] flex flex-col">
                            <label className="text-sm font-medium text-slate-700">Lei Aplicável</label>
                            <input
                                type="text"
                                name="leiAplicavel"
                                value={formData.leiAplicavel}
                                onChange={handleInputChange}
                                className="px-3 py-2 bg-white rounded-md border border-slate-300"
                            />
                        </div>
                        {/* Data Início */}
                        <div className="flex-1 min-w-[200px] flex flex-col">
                            <label className="text-sm font-medium text-slate-700">Data de Início</label>
                            <input
                                type="date"
                                name="dataInicio"
                                value={formData.dataInicio}
                                onChange={handleInputChange}
                                className="px-3 py-2 bg-white rounded-md border border-slate-300"
                            />
                        </div>
                        {/* Data Término */}
                        <div className="flex-1 min-w-[200px] flex flex-col">
                            <label className="text-sm font-medium text-slate-700">Data de Término</label>
                            <input
                                type="date"
                                name="dataTermino"
                                value={formData.dataTermino}
                                onChange={handleInputChange}
                                className="px-3 py-2 bg-white rounded-md border border-slate-300"
                            />
                        </div>
                    </div>
                    {/* Objeto e Observações */}
                    <div className="flex flex-col md:flex-row gap-4">
                        <div className="flex-1 flex flex-col">
                            <label className="text-sm font-medium text-slate-700">Objeto da ATA</label>
                            <textarea
                                name="objetoAta"
                                rows={4}
                                value={formData.objetoAta}
                                onChange={handleInputChange}
                                className="px-3 py-2 bg-white rounded-md border border-slate-300"
                            />
                        </div>
                        <div className="flex-1 flex flex-col">
                            <label className="text-sm font-medium text-slate-700">Observações</label>
                            <textarea
                                name="observacoesAta"
                                rows={4}
                                value={formData.observacoesAta}
                                onChange={handleInputChange}
                                className="px-3 py-2 bg-white rounded-md border border-slate-300"
                            />
                        </div>
                    </div>
                    {/* Licitação Associada */}
                    <div className="flex flex-col md:flex-row flex-wrap gap-4">
                        <div className="flex-1 flex flex-col">
                            <label className="text-sm font-medium text-slate-700">
                                Licitação Associada
                            </label>
                            <select
                                name="edital"
                                className="w-full px-3 py-2 bg-white rounded-md border border-slate-300 text-slate-700 text-base"
                                value={formData.edital}
                                onChange={handleInputChange}
                            >
                                <option value="">Selecionar</option>
                                {editais.map((f) => (
                                    <option key={f.id} value={f.id}>
                                        {f.numeroEdital.toUpperCase()}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                </div>

                {/* Adesão */}
                <div className="flex flex-col gap-4">
                    <h2 className="text-base text-stone-600 font-medium">Adesão</h2>
                    {/* Linha de inputs */}
                    <div className="flex flex-col md:flex-row flex-wrap gap-4">
                        {/* Órgão Solicitante */}
                        <div className="flex-1 min-w-[200px] flex flex-col">
                            <label className="text-sm font-medium text-slate-700">Órgão Solicitante</label>
                            <select
                                name="orgaoSolicitante"
                                className="w-full px-3 py-2 bg-white rounded-md border border-slate-300 text-slate-700 text-base"
                                value={formData.orgaoSolicitante}
                                onChange={handleInputChange}
                            >
                                <option value="">Selecionar</option>
                                {orgaos.map((f) => (
                                    <option key={f.id} value={f.id}>
                                        {f.nome.toUpperCase()}
                                    </option>
                                ))}
                            </select>
                        </div>
                        {/* Valor Solicitado */}
                        <div className="w-[374px] flex flex-col">
                            <label className="text-sm font-medium text-slate-700">
                                Valor Solicitado (R$)
                            </label>
                            <input
                                type="text"
                                name="valorSolicitado"
                                value={formData.valorSolicitado}
                                onChange={handleCurrencyChange('valorSolicitado')}
                                className="px-3 py-2 bg-white rounded-md border border-slate-300"
                            />
                        </div>
                        {/* Número do Ofício */}
                        <div className="w-[374px] flex flex-col">
                            <label className="text-sm font-medium text-slate-700">Número do Ofício</label>
                            <input
                                type="text"
                                name="numeroOficio"
                                value={formData.numeroOficio}
                                onChange={handleInputChange}
                                className="px-3 py-2 bg-white rounded-md border border-slate-300"
                            />
                        </div>
                    </div>
                    {/* Linha 2 */}
                    <div className="flex flex-col md:flex-row flex-wrap gap-4 items-end">
                        <div className="w-[374px] flex flex-col">
                            <label className="text-sm font-medium text-slate-700">Data da Adesão</label>
                            <input
                                type="date"
                                name="dataAdesao"
                                value={formData.dataAdesao}
                                onChange={handleInputChange}
                                className="px-3 py-2 bg-white rounded-md border border-slate-300"
                            />
                        </div>
                        {/* Selecionar Documento */}
                        <div className="grow flex-col gap-1.5 inline-flex">
                            <label className="text-slate-700 text-sm font-normal font-['Inter'] leading-tight">
                                Selecionar Documento
                            </label>
                            <div className="flex gap-2">
                                <div className="relative flex items-center gap-4 w-full">
                                    <input
                                        name="arquivoAdesao"
                                        type="file"
                                        accept=".pdf"
                                        onChange={handleAdesaoFileChange}
                                        className="absolute inset-0 opacity-0 cursor-pointer grow pl-3 pr-14 py-2 bg-white rounded-md border border-slate-300 text-slate-400 text-base"
                                    />
                                    <div className="w-full pl-3 pr-14 py-2 bg-white rounded-md border border-slate-300 flex items-center gap-2">
                                        <span className="text-base text-slate-400">
                                            {fileAdesao ? fileAdesao.name : "Pesquisar Documento"}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <button
                            type="button"
                            className="h-10 px-4 py-2 bg-stone-600 rounded-md inline-flex justify-center items-center gap-2 text-white text-sm"
                            onClick={handleAddAdesao}
                        >
                            <img className="w-4 h-4" src="/images/icon/plus-circle.png" alt="Add" />
                            <span>Adicionar Item</span>
                        </button>
                    </div>
                    {/* Tabela de adesões */}
                    <div className="w-full overflow-auto">
                        <table className="w-full text-left border-collapse">
                            <thead className="bg-stone-200">
                                <tr>
                                    <th className="px-4 py-2 border border-slate-200 text-base font-bold">
                                        Órgão Solicitante
                                    </th>
                                    <th className="px-4 py-2 border border-slate-200 text-base font-bold">
                                        Valor Solicitado (R$)
                                    </th>
                                    <th className="px-4 py-2 border border-slate-200 text-base font-bold">
                                        Número do Ofício
                                    </th>
                                    <th className="px-4 py-2 border border-slate-200 text-base font-bold">
                                        Data da Adesão
                                    </th>
                                    <th className="px-4 py-2 border border-slate-200 text-base font-bold">
                                        Documento Anexado
                                    </th>
                                    <th className="px-4 py-2 border border-slate-200 text-base font-bold">Ver</th>
                                    <th className="px-4 py-2 border border-slate-200 text-base font-bold">
                                        Apagar
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {formData.adesoes.map((item) => {
                                    // Transformar ID em nome
                                    const orgaoEncontrado = orgaos.find(
                                        (o) => o.id === parseInt(item.orgaoSolicitante, 10)
                                    );
                                    const orgaoNome = orgaoEncontrado
                                        ? orgaoEncontrado.nome.toUpperCase()
                                        : item.orgaoSolicitante;
                                    return (
                                        <tr key={item.id}>
                                            <td className="border border-slate-200 px-4 py-2">
                                                {orgaoNome}
                                            </td>
                                            <td className="border border-slate-200 px-4 py-2">
                                                {item.id >= 8000 ? formatCurrencyFromDb(item.valorSolicitado) : item.valorSolicitado}
                                            </td>
                                            <td className="border border-slate-200 px-4 py-2">{item.numeroOficio}</td>
                                            <td className="border border-slate-200 px-4 py-2">{formatDateWithoutHour(item.dataAdesao)}</td>
                                            <td className="border border-slate-200 px-4 py-2">{item.docAnexado}</td>
                                            <td className="border border-slate-200 px-4 py-2 text-center">
                                                <button type="button">
                                                    <img
                                                        src="/images/icon/search.png"
                                                        className="w-6 h-6"
                                                        alt="Ver Documento"
                                                        onClick={() => handleViewPdf(item.arquivo)}
                                                    />
                                                </button>
                                            </td>
                                            <td className="border border-slate-200 px-4 py-2 text-center">
                                                <button type="button" onClick={() => handleRemoveAdesao(item.id)}>
                                                    <img src="/images/icon/trash.png" className="w-6 h-6" alt="Apagar" />
                                                </button>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* Reajuste de Valor */}
                <div className="flex flex-col gap-4">
                    <h2 className="text-base text-stone-600 font-medium">Reajuste de Valor</h2>
                    <div className="flex flex-col md:flex-row flex-wrap gap-4">
                        {/* Reajuste Permitido? */}
                        <div className="w-[183px] flex flex-col">
                            <label className="text-sm font-medium text-slate-700">Reajuste Permitido?</label>
                            <div className="flex items-center gap-4 mt-2">
                                <label className="flex items-center gap-2">
                                    <input
                                        type="radio"
                                        name="reajustePermitido"
                                        checked={!formData.reajustePermitido}
                                        onChange={() => {
                                            setFormData((prev) => ({ ...prev, reajustePermitido: false }));
                                        }}
                                    />
                                    <span>Não</span>
                                </label>
                                <label className="flex items-center gap-2">
                                    <input
                                        type="radio"
                                        name="reajustePermitido"
                                        checked={formData.reajustePermitido}
                                        onChange={() => {
                                            setFormData((prev) => ({ ...prev, reajustePermitido: true }));
                                        }}
                                    />
                                    <span>Sim</span>
                                </label>
                            </div>
                        </div>
                        {/* Data de Início do Reajuste */}
                        <div className="flex-1 min-w-[200px] flex flex-col">
                            <label className="text-sm font-medium text-slate-700">
                                Data de Início do Reajuste
                            </label>
                            <input
                                type="date"
                                name="dataInicioReajuste"
                                value={formData.dataInicioReajuste}
                                onChange={handleInputChange}
                                className="px-3 py-2 bg-white rounded-md border border-slate-300"
                            />
                        </div>
                        {/* Data de Término do Reajuste */}
                        <div className="flex-1 min-w-[200px] flex flex-col">
                            <label className="text-sm font-medium text-slate-700">
                                Data de Término do Reajuste
                            </label>
                            <input
                                type="date"
                                name="dataTerminoReajuste"
                                value={formData.dataTerminoReajuste}
                                onChange={handleInputChange}
                                className="px-3 py-2 bg-white rounded-md border border-slate-300"
                            />
                        </div>
                        {/* Tipo de Índice */}
                        <div className="flex-1 min-w-[200px] flex flex-col">
                            <label className="text-sm font-medium text-slate-700">Tipo de Índice</label>
                            <input
                                type="text"
                                name="tipoIndice"
                                value={formData.tipoIndice}
                                onChange={handleInputChange}
                                className="px-3 py-2 bg-white rounded-md border border-slate-300"
                            />
                        </div>
                    </div>
                </div>

                {/* Documentação e Anexos */}
                <div className="flex flex-col gap-4">
                    <h2 className="text-base text-stone-600 font-medium">Documentação e Anexos</h2>
                    <div className="flex flex-col md:flex-row flex-wrap gap-4">
                        {/* Tipo de Documento */}
                        <div className="w-[375px] flex flex-col">
                            <label className="text-sm font-medium text-slate-700">Tipo de Documento</label>
                            <select
                                name="tipoDocumento"
                                className="w-full px-3 py-2 bg-white rounded-md border border-slate-300 text-slate-700 text-base"
                                value={formData.tipoDocumento}
                                onChange={handleInputChange}
                            >
                                <option value="">Selecionar</option>
                                {tiposDocumento.map((f) => (
                                    <option key={f.id} value={f.id}>
                                        {f.nome.toUpperCase()}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="flex flex-col">
                            <label className="text-sm font-medium text-slate-700">Prazo Prorrogação (meses)</label>
                            <input
                                type="number"
                                name="prazoProrrogacao"
                                value={formData.prazoProrrogacao}
                                onChange={handleInputChange}
                                className="px-3 py-2 bg-white rounded-md border border-slate-300"
                            />
                        </div>
                        {/* Selecionar Documento */}
                        <div className="flex-1 flex flex-col">
                            <label className="text-sm font-medium text-slate-700">
                                Selecionar Documento
                            </label>
                            <div className="flex gap-2">
                                <div className="relative flex items-center gap-4 w-full">
                                    <input
                                        name="arquivoDocumento"
                                        type="file"
                                        accept=".pdf"
                                        onChange={handleDocumentoFileChange}
                                        className="absolute inset-0 opacity-0 cursor-pointer grow pl-3 pr-14 py-2 bg-white rounded-md border border-slate-300 text-slate-400 text-base"
                                    />
                                    <div className="w-full pl-3 pr-14 py-2 bg-white rounded-md border border-slate-300 flex items-center gap-2">
                                        <span className="text-base text-slate-400">
                                            {fileDocumento ? fileDocumento.name : "Pesquisar Documento"}
                                        </span>
                                    </div>
                                </div>
                                <button
                                    type="button"
                                    className="px-4 py-2 bg-stone-600 rounded-md flex justify-center items-center gap-2.5 text-white text-sm"
                                    onClick={handleAddDocumento}
                                >
                                    Adicionar
                                </button>
                            </div>
                        </div>
                    </div>
                    {/* Tabela de Documentos */}
                    <div className="w-full overflow-auto">
                        <table className="w-full text-left border-collapse">
                            <thead className="bg-stone-200">
                                <tr>
                                    <th className="px-4 py-2 border border-slate-200 text-base font-bold">Nº</th>
                                    <th className="px-4 py-2 border border-slate-200 text-base font-bold">Tipo</th>
                                    <th className="px-4 py-2 border border-slate-200 text-base font-bold">
                                        Data do Envio
                                    </th>
                                    <th className="px-4 py-2 border border-slate-200 text-base font-bold">
                                        Prazo Prorrogação (Meses)
                                    </th>
                                    <th className="px-4 py-2 border border-slate-200 text-base font-bold">
                                        Ver
                                    </th>
                                    <th className="px-4 py-2 border border-slate-200 text-base font-bold">
                                        Apagar
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {formData.docs.map((doc) => {
                                    const tipoDocEncontrado = tiposDocumento.find(
                                        (td) => td.id === parseInt(doc.tipoDocumento, 10)
                                    );
                                    const tipoDocNome = tipoDocEncontrado
                                        ? tipoDocEncontrado.nome.toUpperCase()
                                        : doc.tipoDocumento;
                                    return (
                                        <tr key={doc.id}>
                                            <td className="px-4 py-2 border border-slate-200">{doc.id}</td>
                                            <td className="px-4 py-2 border border-slate-200">{tipoDocNome}</td>
                                            <td className="px-4 py-2 border border-slate-200">
                                                {formatDateWithHour(doc.dataEnvio)}
                                            </td>
                                            <td className="px-4 py-2 border border-slate-200">
                                                {doc.prazoProrrogacao}
                                            </td>
                                            <td className="border border-slate-200 px-4 py-2 text-center">
                                                <button type="button">
                                                    <img
                                                        src="/images/icon/search.png"
                                                        className="w-6 h-6"
                                                        alt="Ver Documento"
                                                        onClick={() => handleViewPdf(doc.arquivo)}
                                                    />
                                                </button>
                                            </td>
                                            <td className="px-4 py-2 border border-slate-200 text-center">
                                                <button type="button" onClick={() => handleRemoveDoc(doc.id)}>
                                                    <img
                                                        className="w-6 h-6"
                                                        src="/images/icon/trash.png"
                                                        alt="Del"
                                                    />
                                                </button>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* Botões de Ação */}
                <div className="flex items-center w-full gap-4">
                    {isEditMode && podeDeletar && (
                        <button
                            type="button"
                            className="px-4 py-2 bg-red-600 text-white text-sm font-medium rounded-md flex items-center gap-2"
                            onClick={() => setShowConfirmDeleteRegister(true)}
                        >
                            <img className="w-4 h-4" src="/images/icon/trash-2.png" alt="Apagar" />
                            <span>Apagar</span>
                        </button>
                    )}

                    {isEditMode && (
                        <>
                            <button
                                type="button"
                                className="px-4 py-2 bg-slate-600 text-white text-sm font-medium rounded-md flex items-center gap-2"
                                onClick={() => exportarRelatorioAdesoes(formData, orgaos, auth.user.name, logoEmpresa)}
                            >
                                <img className="w-4 h-4" src="/images/icon/pdf.png" alt="Relatório" />
                                <span>Resumo PDF</span>
                            </button>

                            <button
                                type="button"
                                className="px-4 py-2 bg-green-600 text-white text-sm font-medium rounded-md flex items-center gap-2"
                                onClick={() => exportarRelatorioAdesoesExcel(formData, orgaos)}
                            >
                                <img className="w-4 h-4" src="/images/icon/download.png" alt="Excel" />
                                <span>Resumo Excel</span>
                            </button>
                        </>
                    )}


                    <div className="flex gap-4 ml-auto">
                        <button
                            type="button"
                            className="px-4 py-2 bg-stone-600 text-white text-sm font-medium rounded-md flex items-center gap-2"
                            onClick={handleBack}
                        >
                            <img className="w-4 h-4" src="/images/icon/arrow-left.png" alt="Voltar" />
                            <span>Voltar</span>
                        </button>
                        <button
                            type="submit"
                            className="px-4 py-2 bg-stone-600 text-white text-sm font-medium rounded-md flex items-center gap-2"
                        >
                            <img className="w-4 h-4" src="/images/icon/save.png" alt="Salvar" />
                            <span>Salvar</span>
                        </button>
                    </div>
                </div>

                {/* Modal de Visualização de PDF */}
                {showPdfModal && (
                    <div className="fixed top-0 left-0 w-full h-full bg-black/90 z-50 p-10 flex-col justify-start items-end gap-10 inline-flex overflow-hidden">
                        <div className=" rounded-lg w-full max-w-[80%] h-full max-h-[90%] flex flex-col">
                            <div className="flex justify-between items-center p-4">
                                <div className="flex items-center gap-4">
                                    <a href={config.urlArquivo(pdfUrl)} download target="_blank">
                                        <img className="w-6 h-6 relative  overflow-hidden" src="/images/icon/download.png" />
                                    </a>
                                    <div className="w-6 h-6 relative  overflow-hidden" />
                                    <div className="w-6 h-6 relative  overflow-hidden" />
                                </div>
                                <img className="w-6 h-6 relative  overflow-hidden cursor-pointer" src="/images/icon/x.png" onClick={() => setShowPdfModal(false)} />
                            </div>
                            <div className="flex-grow flex justify-center items-center p-4 overflow-hidden">
                                <iframe
                                    src={`${config.urlArquivo(pdfUrl)}#toolbar=0`}
                                    className="w-full h-full border-0"
                                    style={{ border: 'none' }}
                                    title="PDF Viewer"
                                />
                            </div>
                        </div>
                    </div>
                )}
            </form>

            {/* Modais de Confirmação e Sucesso */}
            <ConfirmationModal
                isVisible={showConfirmDialog}
                onConfirm={handleConfirmSubmit}
                onCancel={handleCancelSubmit}
                message="Deseja salvar as informações?"
            />

            <SuccessModal
                isVisible={showSuccessDialog}
                message="Informações salvas com sucesso!"
                onClose={() => setShowSuccessDialog(false)}
            />

            <ConfirmationModal
                isVisible={showConfirmDeleteRegister}
                onConfirm={handleDeleteRegister}
                onCancel={() => setShowConfirmDeleteRegister(false)}
                message="Deseja apagar este registro?"
                textButtonConfirm="Sim"
            />

            <ConfirmationModal
                isVisible={showConfirmRemoveArchiveDialog}
                onConfirm={() => { /* Implementar função para remover arquivo */ }}
                onCancel={() => setShowConfirmRemoveArchiveDialog(false)}
                message="Deseja remover o arquivo deste contrato?"
                textButtonConfirm="Sim"
            />


        </Template >
    );
};

export default CadastrarAta;
